export const LINKEDIN_CAMPAIGN_GOALS = {
  MoreWebsiteActions: 'MoreWebsiteActions',
  MoreBrandAwareness: 'MoreBrandAwareness',
};

export const getLinkedInBidStrategyOptions = (campaignGoal) => {
  if (campaignGoal === LINKEDIN_CAMPAIGN_GOALS.MoreBrandAwareness) {
    return [{
      key: 'MaxReach',
      text: _TL_('Maximize reach'),
      type: 'MaxReach',
    }, {
      key: 'MaxImpressions',
      text: _TL_('Maximize impressions'),
      type: 'MaxImpressions',
    }];
  }

  return [{
    key: 'MaxClicks',
    text: _TL_('Maximize clicks'),
    type: 'MaxClicks',
  }];
};

export const getLinkedInBidStrategyText = (campaign, i18n) => {
  const bidStrategy = campaign?.BiddingScheme?.Type;
  if (bidStrategy === 'MaxReach') {
    return i18n.getString(_TL_('Maximize reach'));
  }
  if (bidStrategy === 'MaxImpressions') {
    return i18n.getString(_TL_('Maximize impressions'));
  }
  return i18n.getString(_TL_('Maximize clicks'));
};
